import { type ColumnDefinition } from '@turnpike/portal-data-grid';
import { DateTime } from 'luxon';
import { useMemo } from 'react';

import { TextCell } from './components/TextCell';
import { TimeCell } from './components/TimeCell';

import type { SystemStatusModel } from '../../model/types/system-status.model';

export const useTableLayoutColumns = () => {
	const columns = useMemo((): ColumnDefinition<SystemStatusModel>[] => {
		return [
			{
				key: 'name',
				title: 'Name',
				width: 220,
				draggable: false,
				render: (_value, row) => <TextCell isBold={true} text={row.name} />,
			},
			{
				key: 'country',
				title: 'Country',
				width: 150,

				render: (_value, row) => <TextCell text={row.country} />,
			},
			{
				key: 'city',
				title: 'City',
				width: 150,

				render: (_value, row) => <TextCell isDark={true} text={row.city} />,
			},
			{
				key: 'created',
				title: 'Created',
				width: 220,
				align: 'center',
				sortFn: (a, b) => {
					const timeA = DateTime.fromISO(a.createdTime).toMillis();
					const timeB = DateTime.fromISO(b.createdTime).toMillis();
					return timeA - timeB;
				},
				render: (_value, row) => <TimeCell text={row.createdTime} />,
			},
			{
				key: 'modified',
				title: 'Modified',
				width: 220,
				align: 'center',
				sortFn: (a, b) => {
					const timeA = DateTime.fromISO(a.modifiedTime).toMillis();
					const timeB = DateTime.fromISO(b.modifiedTime).toMillis();
					return timeA - timeB;
				},
				render: (_value, row) => <TimeCell text={row.modifiedTime} />,
			},
			{
				key: 'total-devices',
				title: 'total devices',
				width: 200,
				align: 'center',
				sortFn: (a, b) => a.devices.total - b.devices.total,
				render: (_value, row) => <TextCell isDark={true} text={row.devices.total} />,
			},
			{
				key: 'total-users',
				title: 'total users',
				width: 200,
				align: 'center',
				sortFn: (a, b) => a.users.total - b.users.total,
				render: (_value, row) => <TextCell isDark={true} text={row.users.total} />,
			},
		];
	}, []);

	return { columns };
};
